import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, FactorSheetNameLookup } from 'shared/types';

export function useFactorSheetName(brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(
    ['factorsheetnames'],
    () =>
      quoteService.getDropdownOptions<FactorSheetNameLookup>({
        brand,
        table: 'factorsheetnamelookup',
        optionColumn: 'factorsheetname',
      }),
    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      retry: false,
    }
  );
  return { types: data, isLoading, isFetching } as const;
}
